/*
Akhila 05/18/2023 3075154998 export file compoenent created
Akhila 05/18/2023 3075154998 bug fixed validation
Sohel 05/18/2023 3075154998 Changes button label
Akhila 05/18/2023 3075154998 loader added in run export
Ravi 05/19/2023 3075154998 Added validation on Start and End Date
Ravi 05/23/2023 3075154998 Added Export Format file Field
Sohel 05/23/2023 3075154998 Added File Format in Payload
Prakash 24/05/2023 3075154998 removie margintop
Akhila 06/06/2023 3075154998 added code and description in action
Akhila 06/14/2023 3075154998 run report fields added condtionally
Ravi 06/23/2023 2698951347 fixed submit issue
Suresh Peddavoora 06/27/2023 2698951347 fixed textfield alignments in dialog box
Ravi 06/15/2023 3075154998 removed by default initial value folder path and output file name
Akhila 30/06/2023 3075154998 condtionaly label name change for folder path and file name
*/
import {
  FormControl,
  Button,
  Checkbox,
  FormHelperText,
} from '@material-ui/core';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
import React, {useEffect, useState, useContext} from 'react';
import {Form, Formik} from 'formik';
import {ThemeContext} from '../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchBasicInfoData,
  exportFileExecute,
  getExportFormatType,
} from '../../../redux/reducers/EDI/index';
import PageLoader from '../../../components/PageLoader';
import * as yup from 'yup';
import GuiAutoComplete from '../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../components/FormComponents/GuiTextField';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import endOfDay from 'date-fns/endOfDay';
import BreadCrums from '../../../util/BreadCrum';
import {submissionStart} from '../../../redux/reducers/CommonActions/commonActions';
import ReportFolderPath from '../../FrameWorks/Reports/AddReport/StepperComponents/ReportFolderPath';
import DialogBox from '../../../components/DialogBox';
import AddFileName from '../../FrameWorks/DataManager/DataManager/AddDataManager/AddFileName';

const ExportFile = ({setExportFileOpen, rowData, resetBasicInfo, exportFile}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [folderPath, setFolderPath] = useState(false);
  const {clientCodeDropdownData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const backslash = '\\';
  const {
    isExportLoader,
  } = useSelector(({ediExport}) => ediExport);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const initialValue = {
    clientNumber: [],
    startTime: null,
    endTime: null,
    // exportFormat: rowData?.exportFormatType
    //   ? getObjects(rowData?.exportFormatType, EXPORT_FORMAT_TYPE, exportFormatTypeData)
    //   : "",
    // outputFileName: basicInfoData?.reportOutputFileName ? basicInfoData?.reportOutputFileName : "",
    // reportpath: basicInfoData?.exportfolderPath ? basicInfoData?.exportfolderPath : "",
  };
  const handleClose = () => {
    setOpen(false);
    setFolderPath(false);
  };
  const onSubmit = (data) => {
    dispatch(submissionStart());
    const clientCode = data?.clientNumber?.map((el) => el?.clientNumber);
    const payload = {
      clientIds: clientCode ? clientCode : [],
      dmCode: rowData?.exportCode ? rowData?.exportCode : '',
      startDate: data?.startTime ? moment(data?.startTime).format('MM-DD-YYYY') : '',
      endDate: data?.endTime ? moment(data?.endTime).format('MM-DD-YYYY') : '',
      // type: "Export",
      // exportFormatType: data?.exportFormat?.value ? data?.exportFormat?.value : "",
      // reportOutputFileName: data?.outputFileName ? data?.outputFileName : "",
      // exportfolderPath: data?.reportpath ? data?.reportpath : "",
    };
    dispatch(exportFileExecute(payload));
  };
  useEffect(() => {
    dispatch(getExportFormatType());
  }, []);
  const codeDm = rowData?.exportCode ? rowData?.exportCode : '';
  useEffect(() => {
    if (codeDm) {
      dispatch(fetchBasicInfoData({dmCode: codeDm}));
    }
  }, [codeDm]);
  const validationSchema = yup.object().shape({
    //   // clientNumber: yup.array().required("Client code is required"),
    startTime: ['Y'].includes(rowData?.auditPrompt) ?
      yup
        .date()
        .nullable()
        .test('startTime', 'Start Date is required', function(value, context) {
          const day = context?.parent;
          if ([null, undefined]?.includes(day?.startTime)) {
            return false;
          } else {
            return true;
          }
        })
        .typeError('Invalid Date Format') :
      null,
    endTime: ['Y'].includes(rowData?.auditPrompt) ?
      yup
        .date()
        .nullable()
        .typeError('Invalid Date Format')
        .test('endTime', 'End Date is required', function(value, context) {
          const day = context?.parent;
          if ([null, undefined]?.includes(day?.endTime)) {
            return false;
          } else {
            return true;
          }
        })
        .test('endTime', 'End date should not be less than Start date', function(date, context) {
          const day = context?.parent;
          const effectiveDate = moment(day?.startTime).format('YYYY-MM-DD');
          const endTime = moment(date).format('YYYY-MM-DD');
          if (endTime < effectiveDate && ![null, undefined]?.includes(day?.startTime)) {
            return false;
          } else {
            return true;
          }
        })
        .max(endOfDay(new Date()), 'End Date cannot be Future Date') :
      null,
    // exportFormat: yup
    //   .mixed()
    //   .test("exportFormat", "Export Format Type is required", (value, ctx) => {
    //     if (!value?.value) {
    //       return false;
    //     } else {
    //       return true;
    //     }
    //   }),
    reportpath: yup
      .mixed()
      .test('reportpath', 'Invalid Report Folder path, Can\'t contain //', function(value, context) {
        const regex = /^(?!.*\/\/)/;
        const {parent} = context;
        if (regex.test(parent?.reportpath)) {
          return true;
        } else {
          return false;
        }
      })
      .test(
        'reportpath',
            `Invalid Report Folder path, Can't contain ${backslash + backslash}`,
            function(value, context) {
              const {parent} = context;
              if (parent?.reportpath && (parent?.reportpath).includes(`${backslash + backslash}`)) {
                return false;
              } else {
                return true;
              }
            },
      ),
  });
  return (
    <>
      <Formik
        onSubmit={(values) => onSubmit(values)}
        initialValues={initialValue}
        validationSchema={validationSchema}
        enableReinitialize
      >
        {(props) => {
          const {values, setFieldValue, handleBlur, handleChange, errors, touched, resetForm} =
            props;
          return (
            <>
              <Form autoComplete="off" noValidate>
                <div className="col-12">
                  <div className="form-row standard-field-textfields new-standard-textfields">
                    <div className=" col-md-12 form-group">
                      {/* <Typography variant="h4">Export Code: {rowData?.dmCode}</Typography> */}
                      <BreadCrums
                        name={
                          'Code'
                          // type === "Export"
                          //   ? "Export Template Record Code" :  "Import Template Record Code"
                        }
                        code={rowData?.exportCode}
                        description={
                          'Description'
                          // type === "Export"
                          //   ? "Export Template Record Code Description" :"Import Template Record Description"
                        }
                        descriptionValue={rowData?.exportDescription}
                      />
                    </div>
                    {['Y'].includes(rowData?.clientPrompt) && (
                      <div
                        className={`col-sm-6 col-md-4 col-lg-4 col-xl-6 form-group autocomplete-field ${
                          values?.user?.length > 2 && `autocomplete-checkbox`
                        }`}
                      >
                        <FormControl margin="dense" variant="outlined" fullWidth>
                          <GuiAutoComplete
                            name="clientNumber"
                            id="clientNumber"
                            size="small"
                            limitTags={1}
                            classes={{
                              option: classes.option,
                              listbox: classes.listBox,
                            }}
                            disableCloseOnSelect
                            getOptionSelected={(option, value) =>
                              option?.clientNumber === value?.clientNumber
                            }
                            value={values?.clientNumber?.length > 0 ? values?.clientNumber : []}
                            multiple
                            onChange={(e, value) => {
                              handleChange(e);
                              setFieldValue('clientNumber', value);
                            }}
                            options={clientCodeDropdownData || []}
                            autoHighlight
                            renderOption={(option, {selected}) => {
                              return (
                                <React.Fragment>
                                  <>
                                    <Checkbox
                                      icon={icon}
                                      checkedIcon={
                                        <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                      }
                                      checked={selected}
                                    />
                                  </>
                                  {/* {option?.clientNumber} - {option?.clientName} */}
                                  {option?.clientName}
                                </React.Fragment>
                              );
                            }}
                            getOptionLabel={(option) => {
                              // return option?.clientNumber + " - " + option?.clientName;
                              return option?.clientName;
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  variant="outlined"
                                  className={` autocomplete-multiselect-label ${classes.labelName}`}
                                  margin="dense"
                                  touched={touched}
                                  // error={touched?.clientNumber && errors?.clientNumber}
                                  // InputLabelProps={{ shrink: true }}
                                  label={'Client Code'}
                                  placeholder={`Select Client Code`}
                                  // required
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: 'off', // disable autocomplete and autofill
                                  }}
                                />
                              </div>
                            )}
                          />
                        </FormControl>
                        <FormHelperText variant="outlined">
                          {touched?.clientNumber && errors?.clientNumber ? errors.clientNumber : ''}
                        </FormHelperText>
                      </div>
                    )}
                    {['Y'].includes(rowData?.auditPrompt) && (
                      <div className="col-sm-6 col-md-8 col-lg-8 col-xl-6 form-group start-enddate">
                        <div className="row">
                          <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 form-group start-enddate">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                className={` ${classes.labelName}`}
                                format="MM/dd/yyyy"
                                placeholder="MM/DD/YYYY"
                                fullWidth
                                value={values.startTime}
                                disableFuture={true}
                                name="startTime"
                                onBlur={handleBlur}
                                inputVariant="outlined"
                                required
                                helperText=""
                                label="Start Date"
                                onChange={(val) => {
                                  setFieldValue('startTime', val);
                                }}
                                autoOk
                                margin="dense"
                                touched={touched?.startTime}
                                error={Boolean(touched?.startTime && errors?.startTime)}
                              />
                            </MuiPickersUtilsProvider>
                            <FormHelperText variant="outlined">
                              {touched?.startTime && errors?.startTime ? errors.startTime : ''}
                            </FormHelperText>
                          </div>
                          <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 form-group start-enddate">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                className={` ${classes.labelName}`}
                                format="MM/dd/yyyy"
                                placeholder="MM/DD/YYYY"
                                fullWidth
                                value={values.endTime}
                                disableFuture={true}
                                name="endTime"
                                required
                                onBlur={handleBlur}
                                inputVariant="outlined"
                                helperText=""
                                label="End Date"
                                onChange={(val) => {
                                  setFieldValue('endTime', val);
                                }}
                                autoOk
                                margin="dense"
                                touched={touched?.endTime}
                                error={Boolean(touched?.endTime && errors?.endTime)}
                              />
                            </MuiPickersUtilsProvider>
                            <FormHelperText variant="outlined">
                              {touched?.endTime && errors?.endTime ? errors.endTime : ''}
                            </FormHelperText>
                          </div>
                        </div>
                      </div>
                    )}
                    {
                      <div className="col-md-12 d-flex justify-content-center mb-2">
                        {(['Y'].includes(rowData?.auditPrompt) ||
                          ['Y'].includes(rowData?.clientPrompt)) && (
                          <Button
                            variant="outlined"
                            className={`reset-btn mr-1 ${classes.buttonRoot}`}
                            onClick={() => {
                              resetForm(initialValue);
                            }}
                          >
                            Reset
                          </Button>
                        )}
                        <Button
                          variant="outlined"
                          type="submit"
                          className={`search-btn ml-1 ${classes.buttonRoot} `}
                          disabled={enabledSubmission}
                        >
                          Run
                        </Button>
                      </div>
                    }
                  </div>
                </div>
                <DialogBox
                  open={open}
                  dialogClose={handleClose}
                  hideFooter={true}
                  maxWidth={'xl'}
                  title={`Export File Name`}
                >
                  <AddFileName
                    setFieldValues={setFieldValue}
                    setOpen={setOpen}
                    addValues={values}
                    handleClose={handleClose}
                    export={true}
                  />
                </DialogBox>
                <DialogBox
                  open={folderPath}
                  dialogClose={handleClose}
                  hideFooter={true}
                  maxWidth={'xl'}
                  title={`Export Folder Path`}
                >
                  <ReportFolderPath
                    setFieldValues={setFieldValue}
                    setOpen={setOpen}
                    addValues={values}
                    handleClose={handleClose}
                    folderPath={folderPath}
                    export={true}
                  />
                </DialogBox>
              </Form>
            </>
          );
        }}
      </Formik>
      {isExportLoader && <PageLoader />}
    </>
  );
};

export default ExportFile;
